import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {AuthenticatedBaseComponent} from '../../authenticated-base.component';
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {TranslateService} from '@ngx-translate/core';
import {ContentHeaderService} from '../../../services/content-header.service';
import {TitleService} from '../../../services/title.service';
import {Backend} from '@generated-backend-types';
import {take, takeUntil} from 'rxjs';
import Patient = Backend.App.Resources.Dashboard.Patient;
import {ActivatedRoute} from '@angular/router';
import {TableComponent} from '../../../components/table/table.component';
import SentEmail = Backend.App.Resources.Dashboard.SentEmail;
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';
import {SentEmailService} from '../../../services/api/administration/sent-email.service';

@Component({
  selector: 'app-authenticated-patients-emails',
  templateUrl: './emails.component.html',
  providers: [BsModalService],
  standalone: true,
  imports: [
    TabSwitcherComponent,
    TableComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailsComponent extends AuthenticatedBaseComponent implements OnInit {
  public patient?: Patient;

  @ViewChild('emailPreviewModal') protected emailPreviewModalTemplateRef?: TemplateRef<string>;
  protected previewHtmlModalRef?: BsModalRef;
  protected previewHtml: SafeHtml = '';

  public constructor(
    protected override readonly cdr: ChangeDetectorRef,
    protected override readonly translate: TranslateService,
    protected override readonly contentHeaderService: ContentHeaderService,
    protected override readonly titleService: TitleService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly modalService: BsModalService,
    private readonly sanitizer: DomSanitizer,
    private readonly toastrService: ToastrService,
    private readonly sentEmailService: SentEmailService,
  ) {
    super(cdr, translate, contentHeaderService, titleService);
  }

  public ngOnInit() {
    this.activatedRoute.data.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      const patient: Patient | undefined = data['patient'];

      if (patient) {
        this.patient = patient;
        this.cdr.markForCheck();
      }

      this.titleService.setTitle('authenticated.patients.emails.title');
    });
  }

  public showEmail(email: SentEmail) {
    if (!email.generated_email_content) {
      this.sentEmailService.get(email.id, true).subscribe(res => {
        if (!res.data.generated_email_content) {
          this.toastrService.warning(this.translate.instant('authenticated.patients.emails.no_content_message'));
          return;
        }

        this.showEmail(res.data);
      });

      return;
    }

    this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(email.generated_email_content);
    this.previewHtmlModalRef = this.modalService.show(this.emailPreviewModalTemplateRef!, {class: 'email-preview-modal'});
    this.cdr.markForCheck();

    this.previewHtmlModalRef.onHide?.pipe(take(1)).subscribe(() => {
      this.previewHtml = '';
      this.cdr.markForCheck();
    });
  }
}
